export default __webpack_public_path__ + "static/bannerbox.stadtamthall-ec03d7f4b8c565ef93159186d929f8d5.png";